export default {
  namespaced: true,
  chat: {
    error: "Você não tem um usuário de bate-papo",
    new_message: "Novo mensagem de {user}",
    new_emergency_chat: "Novo Chat de Emergência",
    emergency_groups: "Chats de Emergência",
    group_name: "Nome do grupo",
    users: "Usuários",
    chats: "Chats",
    contacts: "Contatos",
    chats_group: "Grupo de Chats",
    start_conversation: "Iniciar conversa",
    send: "Enviar",
    eliminated : "Eliminado",
    added : "Adicionou",
    no_room_found_text: "Nenhuma sala encontrada",
    end_chat: "Encerrar",
    chat_has_ended: "O chat foi encerrado.",
    finalized: "Finalizado",
    assigned: "Atribuído",
    all: "Tudo",
  }
}
